<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="修改密码"
        width="550px"
        append-to-body
        :before-close="handleClose">
        <el-form ref="form" :rules="rules" :model="formItem" label-width="120px" class="pr20">
            <el-form-item label="原密码：" prop="old_password">
                <el-input type="password" v-model.trim="formItem.old_password" placeholder="请输入该账号原密码" show-password></el-input>
            </el-form-item>
            <el-form-item label="新密码：" prop="password">
                <el-input type="password" v-model.trim="formItem.password" placeholder="8-16位，包含数字、字母、字符至少两种以上组合" show-password></el-input>
            </el-form-item>
            <el-form-item label="确认新密码：" prop="confirm_password">
                <el-input type="password" v-model.trim="formItem.confirm_password" placeholder="请再次输入新密码" show-password></el-input>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">确认修改</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/home.js';

    export default {
        name: "Password",
        data() {
            let _this = this;
            const passwordValid = (rule, value, callback) => {
                let a = 0,b = 0,c = 0;
                for(let i = 0; i < value.length; i++){
                    let char = value.charCodeAt(i);
                    if(char >= 48 && char <= 57){
                        a = 1;
                    }else if((char >= 65 && char <= 90) || (char >= 97 && char <= 122)){
                        b = 1;
                    }else{
                        c = 3;
                    }
                }
                (a+b+c) >= 2 ? callback() : callback(new Error(rule.message));
            };

            return {
                dialogVisible: false,
                submitLoading:false,
                formItem:{
                    old_password:'',
                    password:'',
                    confirm_password:'',
                },
                rules:{
                    old_password: [
                        { required: true, message: '请输入原密码', trigger: 'blur' },
                        { type: 'string', min: 8, message: '密码最短8位', trigger: 'blur' },
                        { type: 'string', max: 16, message: '密码最长16位', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入新密码', trigger: 'blur' },
                        { type: 'string', min: 8, message: '密码最短8位', trigger: 'blur' },
                        { type: 'string', max: 16, message: '密码最长16位', trigger: 'blur' },
                        { validator: passwordValid, message: '密码由为8-16位字母、数字、字符两种以上组合', trigger: 'blur' }
                    ],
                    confirm_password: [
                        { required: true, message: '请再次输入密码', trigger: 'blur' },
                        { validator: function(rule, value, callback){
                                if (_this.formItem.password != value) {
                                    callback(new Error('两次密码不一致'));
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur'
                        }
                    ],
                }

            }
        },
        computed: {

        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            showModal() {
                this.dialogVisible = true;
            },
            handleBind() {
                this.$emit('bindWX');
            },
            resetForm(){
                this.submitLoading = false;
                this.$refs['form'].resetFields();
            },
            handleSubmit(){
                this.$refs['form'].validate((valid) => {
                    if (valid) {

                        API.editPassword(this.formItem).then(res => {
                            this.$message.success(res.info || '操作成功');
                            this.dialogVisible = false;
                            this.resetForm();
                        }, (err) => {
                            console.log('editPassword error', err);
                            this.$message.error(err.info || '操作失败');
                            this.submitLoading = false;
                        });

                    } else {
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .action-btn{
        width: 120px;
    }
</style>
